module.exports = __webpack_public_path__ + "img/Promotion.e67899f7.svg";